import { observable, action, makeObservable } from 'mobx';
import { NumberInputType, ISelectValueType, ValueType } from './types';

export class NumberInput implements NumberInputType {
  dataType: 'number';

  label: string;

  placeholder: string;

  tag: string;

  dropDownValues?: { [index: string]: number };

  @observable value: number | undefined | null;

  @observable selectorValue: ValueType<ISelectValueType> | undefined;

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    label,
    placeholder,
    dataType,
    tag,
    error,
    dropDownValues,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: // onChange
  NumberInputType) {
    if (dataType !== 'number')
      throw Error(
        `Type mismatch. Type must be of "number", instead saw "${dataType}"`,
      );
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.dropDownValues = dropDownValues;
    this.placeholder = placeholder as string;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null);
  }

  @action
  onChange = (v: string | undefined | null | number) => {
    if (typeof v === 'number') {
      this.value = v;
    } else if (v !== '' && typeof v === 'string') {
      this.value = v.indexOf('.') < 0 ? parseInt(v, 10) : parseFloat(v);
    } else {
      this.value = null;
    }
  };

  @action
  clearValue = () => {
    this.value = null;
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
